<template>
  <v-dialog v-model="internalValue" persistent max-width="400">
    <v-card>
      <v-card-title :class="titleClass" class="d-flex align-center gap-3">
        <v-icon class="mr-4" :color="iconColor">{{ icon }}</v-icon>
        {{ title }}
      </v-card-title>

      <v-card-text class="text-wrap text-gray-700">
        {{ message }}
      </v-card-text>

      <v-card-actions class="justify-center">
        <v-btn :color="confirmColor" class="btn-custom" variant="flat" @click="confirmAction">
          {{ confirmText }}
        </v-btn>
        <v-btn v-if="buttons!='1'" color="black" class="btn-custom text-white" variant="flat" @click="cancelAction">
          {{ cancelText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref, watch } from 'vue'

const props = defineProps({
  modelValue: Boolean,
  title: String,
  message: String,
  titleClass: { type: String, default: '' },
  iconColor: { type: String, default: 'primary' },
  confirmColor: { type: String, default: 'primary' },
  confirmText: { type: String, default: 'CONFIRM' },
  cancelText: { type: String, default: 'CANCEL' },
  icon: { type: String, default: 'mdi-alert-circle' },
  buttons: { type: String, default: '2' }
})

const emit = defineEmits(['update:modelValue', 'confirm', 'cancel'])

// Creamos un binding interno para v-model
const internalValue = ref(props.modelValue)

// Sincronizamos cambios desde el padre
watch(() => props.modelValue, val => internalValue.value = val)

// Emitimos cambios hacia el padre
watch(internalValue, val => emit('update:modelValue', val))

function confirmAction() {
  emit('confirm')
  internalValue.value = false
}

function cancelAction() {
  emit('cancel')
  internalValue.value = false
}
</script>
